export default __webpack_public_path__ + "static/char-s-14-en-0db829e13c9b3b02892e5bbbb5c30b45.png";